

import React, { useEffect, useState } from "react";
import { fetchInvoicesHeaders } from "../Api/VendorInvoice";
import VIMInvoiceGrid from "./VIMInvoiceGrid";
import "../Styling/PayrollTheme.css";

const VIMInvoicePage = () => {
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(true);

useEffect(() => {
  const loadData = async () => {
    try {
      const result = await fetchInvoicesHeaders();

      console.log("Headers API Result:", result);

      setData(Array.isArray(result) ? result : []);
    } catch (err) {
      console.error("Fetch headers failed:", err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  loadData();
}, []);

  return (
    <div className="pac-cockpit__page">
      <div className="pac-cockpit__header">
        <h2 className="pac-cockpit__title">
          VIM Invoice Management
        </h2>

        <p className="pac-cockpit__subtitle">
          View invoice headers and item details
        </p>
      </div>

      {loading ? (
        <div className="pac-cockpit__loading">
          <span className="pac-cockpit__loading-dot" />
          <span className="pac-cockpit__loading-dot" />
          <span className="pac-cockpit__loading-dot" />
        </div>
      ) : (
        <VIMInvoiceGrid data={data} />
      )}
    </div>
  );
};

export default VIMInvoicePage;